import axios from "axios";

const client_base_url = process.env.REACT_APP_CLIENT_BASE_URL;
const base_url = process.env.REACT_APP_BASE_URL;
const saas_api_urll = process.env.REACT_APP_SAAS_API_URL;
const eass_url = process.env.REACT_APP_CLIENT_BASE_URL;

const getImageBaseUrl = async () => {
  try {
    const response = await axios.get(`https://api.gamerji.tech/api/bucket/url`);
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "An error occurred",
      status: error?.response?.status || 500,
    };
  }
};
// let imageBaseUrl = "https://gamerji-uploads.s3.amazonaws.com"; // Default fallback value
// let imageBaseUrl = "https://gamerji-uploads.s3.amazonaws.com"; // Default fallback value// let imageBaseUrl = "https://gamerji-uploads.s3.amazonaws.com"; // Default fallback value
let imageBaseUrl = ""; // Default fallback value
const initializeS3BaseUrl = async () => {
  
  const s3_base_url_new = await getImageBaseUrl();
  if (!s3_base_url_new.success) {
    console.error("Error fetching S3 base URL:", s3_base_url_new.message);
    return;
  }
  console.log("S3 Base URL fetched successfully:", s3_base_url_new.data);
  imageBaseUrl = s3_base_url_new.data.url;
  return imageBaseUrl
};

const imageUrlBase = (await initializeS3BaseUrl())?.replace(/\/+$/, "");

export const url = {
  apiUrl: base_url + "api/web/",
  apiUrlWebapp: base_url + "api/webapp/",
  saasApiUrl: saas_api_urll + "api/",
  publicUrl: base_url + "api/public/",
  imageUrl: imageUrlBase + "/",
  gamesUrl: saas_api_urll + "api/game/",
  gamesTypesUrl: saas_api_urll + "api/gameType/",
  apiUrlV2: base_url + "api/v2/",
  scrim_url: saas_api_urll + "api/v2/scrim/",
  saasApiUrlV2: saas_api_urll + "api/v2/",
  client_base_url: client_base_url,
  saasApiD11Url: saas_api_urll + "api/web/",
  authUrl: base_url + "api/auth/",
};